<template>
    <div>
        <div class="explanation" v-if="canEditPortfolio">
            <label>Toelichting:</label>
            <p class="text">
                {{ $t('assignment.part.fill_in_the_blanks_description') }}
            </p>
        </div>
        <b-form-textarea
            v-if="canEditPortfolio"
            class="apprentice-textarea"
            v-model="rawText"
            :placeholder="$t('assignment.part.fill_in_the_blanks_placeholder')"
            rows="3"
            max-rows="6">
        </b-form-textarea>

        <div class="preview">
            <h6 class="title">{{ $t('common.preview')}}:</h6>

            <design-2021-fill-in-the-blanks-component
                :text="computedText">
            </design-2021-fill-in-the-blanks-component>
        </div>

        <b-button
            v-if="canEditPortfolio"
            variant="primary"
            class="btn-save"
            @click="submit()">
            {{ $t('common.save') }}
        </b-button>

    </div>
</template>

<script>
    export default {
        name: 'design-2021-assignment-edit-part-fill-in-the-blanks-component',
        props: {
            partIn: {
                type:Object,
                required: true,
            },
            canEditPortfolio: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                rawText: this.partIn.fill_in_the_blanks_text ? this.partIn.fill_in_the_blanks_text.text_with_blanks : '',
                blanks: [],
            };
        },
        computed: {
            computedText() {
                return this.rawText;
            }
        },
        methods: {
            escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            },
            submit() {
                const data = {
                    text_with_blanks: this.rawText
                };

                this.axios.post(this.routes.assignmentPartFillInTheBlanks(this.partIn.id), data).then(
                    (response) => {
                        this.$emit('part-updated', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            }
        }
    };
</script>


<style scoped lang="scss">
.explanation {
    margin-top: $grid-gutter-width;

    label {
        font-weight: $font-weight-light;
    }

    .text {
        font-weight: $font-weight-medium;
        font-size: $default-font-size;
    }
}

.preview {
    margin: map-get($grid-gutter-spacing, 'forty-two') 0;
}
</style>